import type {BlogGlobal} from '~/payload-types'

export function useBlogMeta() {
  const sdk = usePayloadSdk()
  const route = useRoute()

  const fetch = async () => {
    const result = await sdk.findGlobal({
      slug: 'blogGlobal',
      depth: 1,
      draft: !!route.query.preview,
    })
    return result as BlogGlobal
  }

  return {fetch}
}
